module.exports = __webpack_public_path__ + "img/white-card-display.61748aaa.png";